<template>
  <el-table class="tb-c-head" :data="Dts" border>
    <el-table-column label="产品编码" prop="ProductNo" min-width="120" show-overflow-tooltip />
    <el-table-column label="产品名称" prop="ProductName" min-width="120" />
    <el-table-column label="颜色" prop="ColorName" min-width="70" />
    <el-table-column label="属性" prop="PropertyName" min-width="70" />
  </el-table>
</template>
<script>
export default {
  data() {
    return {
      api: require("@/api/sy/user").default,
      Dts: [],
    };
  },
  methods: {
    setData(arr) {
      // console.log("setData", id);
      // this.api.info(id).then((res) => {
      //   if (res.Code == 0) this.Dts = res.Data.Dts;
      // });
      this.Dts = arr;
    },
    clear() {
      this.Dts = [];
    },
  },
};
</script>